import axios, { AxiosResponse } from "axios";
import { APP_Config } from "../helpers/AppConfig";
import { IQuestionnaireModel } from "../tsmodels/QuestionnaireModel";
import { Questions } from "../tsmodels/CategoryModals";

class Appservice {
  base_url = APP_Config()?.REACT_APP_BASE_URL;
  getData = "/prospect/getData";

  //---/prospect/postFile
  getQuestionnaireList = (
    data: any
  ): Promise<AxiosResponse<IQuestionnaireModel[]>> =>
    axios.post(`${this.base_url}${this.getData}`, data);

  getDocumentList = (
    data: any
  ): Promise<AxiosResponse<IQuestionnaireModel[]>> =>
    axios.post(`${this.base_url}${this.getData}`, data);

  getApiData = (data: any): Promise<AxiosResponse<IQuestionnaireModel[]>> =>
    axios.post(`${this.base_url}${this.getData}`, data);

  updateQuestionDescription = (
    description: string,
    questionId: string
  ): Promise<AxiosResponse<any>> =>
    axios.post(
      `${this.base_url}/prospect/updateQuestionDescription?description=${description}&questionId=${questionId}`
    );

  SaveDocumentExtractFields = (
    data: any
  ): Promise<AxiosResponse<IQuestionnaireModel[]>> =>
    axios.post(`${this.base_url}/prospect/SaveDocumentExtractFields`, data);

  getQuestionsList = (data: any): Promise<AxiosResponse<any>> =>
    axios.post(`${this.base_url}${this.getData}`, data);

  saveverifyAllDocFields = (
    documentId: any,
    verify: boolean
  ): Promise<AxiosResponse<any>> =>
    axios.post(
      `${this.base_url}/prospect/verifyAllDocFields?documentId=${documentId}&isVerified=${verify}`
    );

  saveExtreactedFieldMappings = (
    documentId: any
  ): Promise<AxiosResponse<any>> =>
    axios.post(
      `${this.base_url}/prospect/saveExtreactedFieldMappings?documentId=${documentId}`
    );

  getExtractedList = (files: any = [], questionnaire: any) => {
    const formData = new FormData();  
    files.forEach((file: any) => {
      formData.append("multipartFile", file);
    });
    formData.append("questionarieId", questionnaire); 
    formData.append("orgId", "a3fe60fe-3f6f-11ee-be56-0242ac120002", ); 
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        
      },
    };
    return axios.post(`${this.base_url}/prospect/postFile`, formData, config);
  };

  addQuestionFieldMapping = (data: any): Promise<AxiosResponse<any>> =>
    axios.post(`${this.base_url}/prospect/addQuestionFieldMapping`, data);
  
  updateQuestionTags= (data: any): Promise<AxiosResponse<any>> =>
    axios.post(`${this.base_url}/prospect/updateQuestionTags`, data);

  updateDocStatus = (data: any) =>
    axios.put(`${this.base_url}/prospect/updateDocStatus`, data);
clearQuestionFieldMapping = (data: any): Promise<AxiosResponse<any>> =>
  axios.post(`${this.base_url}/prospect/clearQuestionFieldMapping`, data);

getValidation = (data: any): Promise<AxiosResponse<IQuestionnaireModel[]>> =>
  axios.post(`${this.base_url}${this.getData}`, data);

}

export default Appservice;
